export default "__VITE_ASSET__PELBC55n__"